import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { tokenStore } from "./api/token";
import "./styles/app.css";
import "./styles/splash.css";

// Mirror of server's AUTH_DEV_BYPASS: skip SSO entirely on local dev.
if (import.meta.env.VITE_AUTH_DEV_BYPASS === "true" && !tokenStore.get()) {
  tokenStore.setBypass("dev-bypass");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root missing in index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
